/* EAGLE CUSTOM 2026-10-24 – sub-category cards: switch collection without a full page reload (go-live task 25).
   Same technique as Jakamen (jakamen-subnav.js): click a card -> Section Rendering API returns the target collection's
   breadcrumbs section (holds the cards) + product-grid section -> swapped in; URL (pushState, real collection URL),
   title and a page view (GA4 gtag / GTM dataLayer / Shopify custom event / Meta / TikTok if present).
   Responses are prefetched on hover / touch and cached 2 minutes. Back/forward between collections also swaps by AJAX.
   Target on another template (section missing) or any error -> normal page load. Cards: snippets/eagle-subcats.liquid. */
(function () {
  if (window.EagleSubcats || !window.fetch || !history.pushState) return;
  window.EagleSubcats = true;
  var cache = {}, rendered = location.pathname;

  // product grid = the section with #ProductGridContainer; the cards sit in the breadcrumbs section above it
  function gridSection() { var g = document.getElementById('ProductGridContainer'); return g && g.closest('.shopify-section'); }
  function cardsSection() { var n = document.querySelector('[data-eagle-subcats]'); return n && n.closest('.shopify-section'); }
  function sid(el) { return el.id.replace('shopify-section-', ''); }
  function ids() {
    var out = [], g = gridSection(), c = cardsSection();
    if (c) out.push(sid(c));
    if (g) out.push(sid(g));
    return out;
  }
  function key(url) { var u = new URL(url, location.origin); return u.pathname + u.search; }

  function request(url) {
    var k = key(url);
    if (cache[k]) return cache[k];
    var list = ids(), u = new URL(url, location.origin);
    u.searchParams.set('sections', list.join(','));
    var p = fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) { return { ids: list, data: data }; });
    cache[k] = p;
    p.catch(function () { delete cache[k]; });
    setTimeout(function () { delete cache[k]; }, 120000);
    return p;
  }

  function swap(res) {
    if (res.ids.length < 2) return false;
    for (var i = 0; i < res.ids.length; i++) if (res.data[res.ids[i]] == null) return false;
    res.ids.forEach(function (id) {
      var cur = document.getElementById('shopify-section-' + id); if (!cur) return;
      var doc = new DOMParser().parseFromString(res.data[id], 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
      if (fresh) cur.innerHTML = fresh.innerHTML;
    });
    return true;
  }

  function track() {
    var pv = { page_location: location.href, page_title: document.title, page_path: location.pathname };
    try { if (window.gtag) gtag('event', 'page_view', { page_location: pv.page_location, page_title: pv.page_title }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'eagle_virtual_pageview', page_location: pv.page_location, page_title: pv.page_title }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('eagle_virtual_pageview', pv); } catch (e) {}
    try { if (window.fbq) fbq('track', 'PageView'); } catch (e) {}
    try { if (window.ttq && ttq.page) ttq.page(); } catch (e) {}
  }

  function keepVisible(nav, scrollLeft) {
    var list = nav.querySelector('.eagle-subcats__list'); if (!list) return;
    list.scrollLeft = scrollLeft;
    var act = list.querySelector('.is-active'); if (!act) return;
    var c = list.getBoundingClientRect(), a = act.getBoundingClientRect();
    if (a.left < c.left || a.right > c.right) list.scrollBy({ left: (a.left + a.width / 2) - (c.left + c.width / 2), behavior: 'smooth' });
  }

  function go(url, push) {
    var root = document.documentElement, grid = gridSection();
    if (!grid || !cardsSection()) { location.assign(url); return; }
    var oldList = document.querySelector('[data-eagle-subcats] .eagle-subcats__list'), sl = oldList ? oldList.scrollLeft : 0;
    root.classList.add('eagle-subcats-busy'); grid.classList.add('eagle-subcats-loading');
    request(url).then(function (res) {
      if (!swap(res)) { location.assign(url); return; }
      if (push) history.pushState({ eagleSubcats: true }, '', url);
      rendered = location.pathname;
      var nav = document.querySelector('[data-eagle-subcats]');
      if (nav) {
        if (nav.dataset.pageTitle) { var t = document.createElement('textarea'); t.innerHTML = nav.dataset.pageTitle; document.title = t.value; }
        keepVisible(nav, sl);
        var top = nav.getBoundingClientRect().top;
        if (top < 0) window.scrollTo({ top: Math.max(0, top + window.pageYOffset - 120), behavior: 'smooth' });
      }
      document.dispatchEvent(new CustomEvent('eagle:subcats-switched', { detail: { url: url } }));
      track();
    }).catch(function () { location.assign(url); })
      .then(function () { root.classList.remove('eagle-subcats-busy'); var g = gridSection(); if (g) g.classList.remove('eagle-subcats-loading'); });
  }

  function link(e) { return e.target.closest && e.target.closest('a[data-eagle-subcat]'); }

  document.addEventListener('click', function (e) {
    var a = link(e);
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.origin !== location.origin) return;
    e.preventDefault();
    if (document.documentElement.classList.contains('eagle-subcats-busy')) return;
    if (a.classList.contains('is-active') && a.pathname === location.pathname && !location.search) return;
    go(a.href, true);
  });

  function warm(e) { var a = link(e); if (a && a.origin === location.origin && !a.classList.contains('is-active')) request(a.href).catch(function () {}); }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });

  // Back / forward to another collection: swap by AJAX (filters inside one collection stay with Pillar's facets.js)
  window.addEventListener('popstate', function (e) {
    if (!document.querySelector('[data-eagle-subcats]')) return;
    if (location.pathname !== rendered) { e.stopImmediatePropagation(); go(location.href, false); }
  });
})();
